import Vue from 'vue'

Vue.prototype.$http = window.axios

export default new Vue({
  data: {
      statusinit:false,
      uploadDialogVidCursor:"",
      newguidVid: "",
      videoGalleryStatus: false,
      uploadVideoAttachment:[],
      galleryVideoId:"",
      instructionVidselected:false,
      uploadDialogtreeVid:[],
      instructionVid:[],
      instructionSelected:false,
      instructionImgselected:false,
      newguidImg:"",
      galleryimageId:"",
      uploadImgAttachment:[],
      dialogTreeGalleryStatus:false,
      uploadDialogImgCursor:"",
      uploadDialogtreeImg:[],
      instructionImg:[],
      languages: [],
      preferredLanguage: null,
      token: null,
      claims: {
          phrases: 0,
          languages: 0,
          users: 0,
          dialogs: 0,
          settings: 0
      },
      phrases: [],
      users: [],
      dialogHasImage: {},
      showUploadImageDialog: false,
      answerImageUploadDialog: false,
      currentDialogId: '',
      changeDeleteImage: false,
      changeDeleteVideo: false,
      dialogHasAttachment: {},
      uploadDialogImgSrc: '',
      uploadDialogVidSrc: '',
      moveDialog: false,
      draggedDialog: {},
      undoStack: [],
      dialogRef: {},
      dialogParent: {},
      reorder: false,
      imageChosen: false,
      videoChosen: false,
      linkChosen: false,
      uploadingInstructionImage: false,
      instructionAttachments:{},
      instructionImages: {},
      instructionImagesId: {},
      editingInstImg: false,
      editingInstImgIndex: 0,
      instructionVideos: {},
      instructionVideosId: {},
      editingInstVid: false,
      editingInstVidIndex: 0,
      instructionVideoLinks: {},
      instructionVideoLinksId: {},
      instructionVideoLinks: {},
      instructionVideoLinksId: {},
      languageFlagExist: {},
      languageFlagSrc: {},
      showUploadFlagDialog: false,
      currentLanguageId: "",
      limit: 500,
      phrasesLoaded: false,
      currentDialogRef:null,
      langDict:{},
  },
  watch: {
    'token': function(newToken) {
        if (newToken) {
            if (this.claims.users & 1) { this.getUsers() }
        }
     }
  },
  methods: {
      undo(e) {
          if (this.undoStack.length) {
              e.preventDefault();
              var elem = this.undoStack[this.undoStack.length - 1];
              if (elem.type === "copy") {
                  if (this.dialogRef[elem.replicated])
                      this.dialogRef[elem.replicated].deleteRootDialog();
                  this.undoStack.pop();
              }
          }
      },
      /**
       * Fetches all languages and populates the store with them
       */
      getLanguages() {
          this.$http
              .get('/languages')
              .then(response => {
                  if (response.data) {
                      this.languages = response.data
                      if (this.languages.length > 0) {
                          this.preferredLanguage = this.languages[0].id
                      }
                      this.checkLanguageAttachment();
                  }
              })
        },
        checkLanguageAttachment() {
            var lang = this.languages;
            lang.forEach(language => {
                if (language.attachments && language.attachments.length) {
                    this.$set(this.languageFlagExist, language.id, true);
                    this.$http
                        .get("languages/" + language.id + "/flag", {
                            responseType: "arraybuffer"
                        })
                        .then(response => {
                            let image = btoa(
                                new Uint8Array(response.data).reduce(
                                    (data, byte) => data + String.fromCharCode(byte),
                                    ""
                                )
                            );
                            var langImg = `data:${response.headers[
                "content-type"
              ].toLowerCase()};base64,${image}`;
                            this.$set(this.languageFlagSrc, language.id, langImg);
                        })
                } else {
                    this.$set(this.languageFlagExist, language.id, false);
                }
            })
        },
        /**
         * Adds a language to store
         * @param {object} language The language to be added
         */
        addLanguage(language) {
            this.languages.push(language)
            if (this.languages.length === 1) {
                this.preferredLanguage = language.id
            }
        },
        /**
         * Removes a language from store (not backend)
         * @param {string} id ID of language to remove
         */
        deleteLanguage(id) {
            this.languages = this.languages.filter(x => x.id !== id)
            if (this.preferredLanguage === id) {
                this.preferredLanguage = this.languages[0]
            }
        },
        /**
         * Fetch all phrases and populate store with them
         */
        getPhrases() {
            return new Promise((resolve, reject) => {
                this.phrases.length = 0;
                this.phrasesLoaded = false;
                var cursorID = "";
                this.getPhrasesLimited(cursorID).then(() => {
                    if (this.phrasesLoaded) {
                        resolve()
                    } else {
                        reject(Error("Couldn't fetch phrases"))
                    }
                }).catch(() => {
                    reject(Error("Couldn't fetch phrases"))
                })
            })
        },

        getPhrasesLimited(cursor) {
            return this.$http.get('/phrases?limit=' + this.limit + '&cursor=' + cursor).then(response => {
                cursor = response.data.Cursor;
                this.$store.phrases = this.$store.phrases.concat(response.data.List);
                if (response.data && response.data.List && response.data.List.length == 0) {
                    this.$store.phrasesLoaded = true
                    this.$http.delete('/phrases?cursor=' + cursor)
                } else if (response.data.length == 0) {
                    this.$store.phrasesLoaded = true
                }
                if (!this.$store.phrasesLoaded) {
                    return this.getPhrasesLimited(cursor)
                }
            }, )
        },

        /**
         * Post a new phrase to backend
         * @param {object} phrase Phrase to post
         */
        postPhrase(phrase) {
            return new Promise((resolve, reject) => {
                this.$http.post('/phrases', JSON.stringify(phrase)).then(
                    response => {
                        this.phrases.push(phrase)
                        resolve(response.data.id)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Put a new phrase to backend
         * @param {object} phrase Phrase to put
         */
        putPhrase(phrase) {
            return new Promise((resolve, reject) => {
                this.$http.put('/phrases/' + phrase.id, phrase).then(
                    response => {
                        const i = this.phrases.findIndex(p => p.id === phrase.id)
                        this.$set(this.phrases, i, phrase)
                        resolve(response)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Put translation to backend phrase that works with multiple translators
         * editing different languages in same phrase.
         * @param {string} phraseID
         * @param {object} translation
         */
        putTranslation(phraseID, translation) {
            var put = this.putPhrase
            return new Promise((resolve, reject) => {
                this.$http.get('/phrases/' + phraseID).then(
                    response => {
                        var p = response.data
                        var oldTranslation = p.translations ? p.translations.filter(t => t.language === translation.language)[0] : undefined;
                        if (typeof oldTranslation === "undefined") {
                            oldTranslation = {
                                text: "",
                                language: translation.language,
                            }
                            p.translations.push(oldTranslation)
                        }
                        oldTranslation.text = translation.text
                        return p
                    },
                    response => {
                        reject(response)
                    }
                ).then(function(result) {
                    put(result).then(
                        response => {
                            resolve(result)
                        },
                        response => {
                            reject(response)
                        }
                    )
                })
            })
        },
        /**
         * Get a dialog by id
         * @param {string} dialog id to get
         */
        getDialogById(dialogID) {
            return new Promise((resolve, reject) => {
                if (dialogID == "") {
                    reject("Cannot get dialog with null id")
                } else {
                    return this.$http.get('/dialogs/' + dialogID).then(
                        response => {
                            resolve(response)
                        }
                    )
                }
            })
        },

        /**
         * Post a new dialog to backend
         * @param {object} dialog Dialog to post
         */
        postDialog(dialog) {
            return new Promise((resolve, reject) => {
                this.$http.post('/dialogs', dialog).then(
                    response => {
                        resolve(response.data.id)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Put a new dialog to backend
         * @param {object} dialog Dialog to put
         */
        putDialog(dialog) {
            return new Promise((resolve, reject) => {
                this.$http.put('/dialogs/' + dialog.id, dialog).then(
                    response => {
                        resolve(response)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Delete a dialog
         * @param {int} id The ID of the dialog to be deleted
         */
        deleteDialog(id) {
            return new Promise((resolve, reject) => {
                this.$http.delete('/dialogs/' + id).then(
                    response => {
                        resolve()
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        getUsers() {
            return new Promise((resolve, reject) => {
                this.$http
                    .get('/auth/users')
                    .then(r => {
                        this.users = r.data
                        resolve(this.users)
                    })
                    .catch(r => {
                        reject(r)
                    })
            })
        }
    },

    /**
     * Computed data-properties.
     * These are cached by Vue until changes are made to source data
     */
    computed: {
        autocompletePhrases: function() {
            var values = {}
            this.phrases.forEach(p => {
                const primaryTranslation = p.translations ? p.translations.filter(t => t.language === this.preferredLanguage) : [];
                if (primaryTranslation.length > 0) {
                    values[primaryTranslation[0].text] = null
                }
            })
            return values
        },
        userID: function() {
            const base64Url = this.token.split('.')[1]
            const base64 = base64Url.replace('-', '+').replace('_', '/')
            return JSON.parse(atob(base64)).id
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js